import React from 'react';
import { describe } from 'react-desc';
import QueryBuilderImpl from './components/QueryBuilderImpl.js';
import { QB_ADD_FILTER_METHOD_TYPES, QB_GROUP_FILTER_METHOD_TYPES, QB_EXPORT_FORMAT_TYPES } from './components/helpers/types.js';
export { QB_ADD_FILTER_METHOD_TYPES, QB_DRAG_LOCATIONS, QB_DRAG_TYPES, QB_EXPORT_FORMAT_TYPES, QB_FIELD_SHARED_ACTIONS, QB_FIELD_TYPES, QB_GROUP_CONDITION_TYPES, QB_GROUP_FILTER_METHOD_TYPES, QB_OPERATOR_TYPES } from './components/helpers/types.js';
export { QB_DEFAULT_VALUES_OPTIONS, QB_FIELD_OPTIONS, QB_LOAN_VALUES_OPTIONS, QB_OPERATOR_OPTIONS, QB_SUBJECT_VALUES_OPTIONS } from './components/helpers/selectors.js';
export { default as QueryBuilderFormat } from './components/format/format.js';
import { props } from './propTypes.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import './components/Nestable/Nestable.js';
import 'prop-types';
import 'classnames';
import '@elliemae/ds-shared/utils';
import '@elliemae/ds-utilities/utils';
import './components/Nestable/actions/tryIncreaseDepth.js';
import './components/Nestable/actions/tryDecreaseDepth.js';
import './components/Nestable/actions/moveItem.js';
import 'react-addons-update';
import './components/Nestable/actions/paths.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import './components/Nestable/actions/events.js';
import './components/Nestable/actions/getItemOptions.js';
import './components/Nestable/NestableItem.js';
import './components/QueryBuilderContext/QueryBuilderContext.js';
import './components/helpers/store.js';
import './components/helpers/actions.js';
import './components/AndOrController/AndOrController.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-basic/Tooltip';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-basic/form/Toggle';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/QueryAdd';
import '@elliemae/ds-icons/ParenthesisRemove';
import '@elliemae/ds-icons/MoreOptionsVert';
import '@elliemae/ds-basic/Icon';
import './components/helpers/constants.js';
import './components/ToolBarAnimation/ToolBarAnimation.js';
import '@elliemae/ds-shared/Animations/GrowRight';
import './components/DragContainerController/DragContainerController.js';
import '@elliemae/ds-icons/GripperVertical';
import './components/QueryBuilderItem/QueryBuilderItem.js';
import './components/QueryBuilderRow/QueryBuilderRow.js';
import './components/helpers/dependencies.js';
import 'lodash';
import '@elliemae/ds-utilities/operators';
import './components/ConditionController/ConditionController.js';
import '@elliemae/ds-icons/QueryRemove';
import '@elliemae/ds-icons/ParenthesisAdd';
import './components/DragControllerRow/DragControllerRow.js';
import './components/DisplayOutput/DisplayOutput.js';
import '@babel/runtime/helpers/esm/typeof';
import '@elliemae/ds-basic/Accordion';
import '@elliemae/ds-icons/ChevronDown';
import '@elliemae/ds-icons/ChevronRight';
import './components/format/sqlFormat.js';
import './components/format/xmlFormat.js';
import './components/format/sqlSafeFormat.js';

var DSQueryBuilder = function DSQueryBuilder(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$addFilterMethod = _ref.addFilterMethod,
      addFilterMethod = _ref$addFilterMethod === void 0 ? QB_ADD_FILTER_METHOD_TYPES.IN_PLACE : _ref$addFilterMethod,
      _ref$groupFilterMetho = _ref.groupFilterMethod,
      groupFilterMethod = _ref$groupFilterMetho === void 0 ? QB_GROUP_FILTER_METHOD_TYPES.IN_PLACE : _ref$groupFilterMetho,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      _ref$fieldsSharedActi = _ref.fieldsSharedActions,
      fieldsSharedActions = _ref$fieldsSharedActi === void 0 ? {
    onFieldChange: [],
    onOperatorChange: [],
    onValueChange: []
  } : _ref$fieldsSharedActi,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? QB_EXPORT_FORMAT_TYPES.DEFAULT : _ref$format,
      _ref$init = _ref.init,
      init = _ref$init === void 0 ? null : _ref$init,
      _ref$ruleContainerCla = _ref.ruleContainerClassName,
      ruleContainerClassName = _ref$ruleContainerCla === void 0 ? '' : _ref$ruleContainerCla,
      _ref$handleDrop = _ref.handleDrop,
      handleDrop = _ref$handleDrop === void 0 ? function () {
    return null;
  } : _ref$handleDrop,
      _ref$handleDropFilter = _ref.handleDropFilter,
      handleDropFilter = _ref$handleDropFilter === void 0 ? function () {
    return null;
  } : _ref$handleDropFilter,
      _ref$handleDropGroup = _ref.handleDropGroup,
      handleDropGroup = _ref$handleDropGroup === void 0 ? function () {
    return null;
  } : _ref$handleDropGroup,
      _ref$handleFieldChang = _ref.handleFieldChange,
      handleFieldChange = _ref$handleFieldChang === void 0 ? function () {
    return null;
  } : _ref$handleFieldChang,
      _ref$handleRuleContai = _ref.handleRuleContainerOperator,
      handleRuleContainerOperator = _ref$handleRuleContai === void 0 ? function () {
    return null;
  } : _ref$handleRuleContai,
      _ref$handleRuleContai2 = _ref.handleRuleContainerUnGroup,
      handleRuleContainerUnGroup = _ref$handleRuleContai2 === void 0 ? function () {
    return null;
  } : _ref$handleRuleContai2,
      _ref$onAddFilter = _ref.onAddFilter,
      onAddFilter = _ref$onAddFilter === void 0 ? function () {
    return null;
  } : _ref$onAddFilter,
      _ref$onAddRuleContain = _ref.onAddRuleContainer,
      onAddRuleContainer = _ref$onAddRuleContain === void 0 ? function () {
    return null;
  } : _ref$onAddRuleContain,
      _ref$onRemoveFilter = _ref.onRemoveFilter,
      onRemoveFilter = _ref$onRemoveFilter === void 0 ? function () {
    return null;
  } : _ref$onRemoveFilter,
      _ref$displayOutput = _ref.displayOutput,
      displayOutput = _ref$displayOutput === void 0 ? false : _ref$displayOutput,
      _ref$displayOutputLab = _ref.displayOutputLabel,
      displayOutputLabel = _ref$displayOutputLab === void 0 ? {
    show: 'Show output',
    hide: 'Hide output'
  } : _ref$displayOutputLab,
      _ref$singleRow = _ref.singleRow,
      singleRow = _ref$singleRow === void 0 ? false : _ref$singleRow,
      _ref$toolTipZIndex = _ref.toolTipZIndex,
      toolTipZIndex = _ref$toolTipZIndex === void 0 ? 110 : _ref$toolTipZIndex;
  return /*#__PURE__*/React.createElement(QueryBuilderImpl, {
    addFilterMethod: addFilterMethod,
    containerProps: containerProps,
    displayOutput: displayOutput,
    displayOutputLabel: displayOutputLabel,
    fields: fields,
    fieldsSharedActions: fieldsSharedActions,
    format: format,
    groupFilterMethod: groupFilterMethod,
    handleDrop: handleDrop,
    handleDropFilter: handleDropFilter,
    handleDropGroup: handleDropGroup,
    handleFieldChange: handleFieldChange,
    handleRuleContainerOperator: handleRuleContainerOperator,
    handleRuleContainerUnGroup: handleRuleContainerUnGroup,
    init: init,
    onAddFilter: onAddFilter,
    onAddRuleContainer: onAddRuleContainer,
    onChange: onChange,
    onRemoveFilter: onRemoveFilter,
    ruleContainerClassName: ruleContainerClassName,
    singleRow: singleRow,
    toolTipZIndex: toolTipZIndex
  });
};

DSQueryBuilder.propTypes = props;
var DSQueryBuilderWithSchema = describe(DSQueryBuilder);
DSQueryBuilderWithSchema.propTypes = props;

export default DSQueryBuilder;
export { DSQueryBuilderWithSchema };
//# sourceMappingURL=DSQueryBuilder.js.map
